/*
  ex. theme.spacing(2); // = 0.25 * 2rem = 0.5rem = 8px
  Allows for fluid typography and dimensions based on rem (root font size)
 */
const spacing = (factor: number) => `${0.25 * factor}rem`;

export { spacing };
